import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const PREFIX = 'GenericEntity';

export const entityClasses = {
  container: `${PREFIX}-container`,
  content: `${PREFIX}-content`,
  left: `${PREFIX}-left`,
  right: `${PREFIX}-right`,
  card: `${PREFIX}-card`,
  section: `${PREFIX}-section`,
  tabs: `${PREFIX}-tabs`,
  grid: `${PREFIX}-grid`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`.${entityClasses.container}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  [`& .${entityClasses.content}`]: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  [`& .${entityClasses.left}`]: {
    flexGrow: 0,
    width: '35%',
  },
  [`& .${entityClasses.right}`]: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    width: '65%',
  },
  [`& .${entityClasses.card}`]: {
    margin: theme.spacing(1),
  },
  [`& .${entityClasses.section}`]: {
    fontSize: 20,
    marginBottom: 10,
  },
  [`& .${entityClasses.grid}`]: {
    flexGrow: 1,
    margin: theme.spacing(1),
  },
  [`& .${entityClasses.grid}`]: {
    '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus':
      {
        outline: 'none',
      },
  },
}));

export default function Entity({ children }: { children: React.ReactNode }) {
  return (
    <StyledBox component="div" className={entityClasses.container}>
      {children}
    </StyledBox>
  );
}
